module.exports = __webpack_public_path__ + "media/images/thanks-a72914aa9d2614ea02b333840f1549f2.png";